// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_oc-0";